import { Center, Text } from '@mantine/core';

type RunInlineEmptyStateProps = {
  message: string;
  minHeight?: number;
};

const RunInlineEmptyState = ({ message, minHeight = 48 }: RunInlineEmptyStateProps) => (
  <Center w="100%" py="sm" mih={minHeight}>
    <Text size="xs" c="dimmed" fw={500}>
      {message}
    </Text>
  </Center>
);

export default RunInlineEmptyState;
